import { CROSS_BASKET_BLOCK, CROSS_PROMO_BLOCK } from "../models/_consts";
import { openModal } from "../features/dashBoard/dashboardSlice";
import { useAppDispatch, useAppSelector } from "../store/configureStore";

// Promo basket and instore basket are mutually exclusive. This hook returns
// guards that block an action and open the cross-basket modal when the other
// basket type is currently in use.
export default function useBasketGate() {
  const dispatch = useAppDispatch();
  const { basket } = useAppSelector((state) => state.basket);
  const instoreItems = useAppSelector((state) => state.instoreBasket.items);

  const promoActive = !!basket;
  const instoreActive = instoreItems.length > 0;

  const blockBasket = () => dispatch(openModal(CROSS_BASKET_BLOCK));
  const blockPromo = () => dispatch(openModal(CROSS_PROMO_BLOCK));

  return {
    promoActive,
    instoreActive,
    // Guard navigation into a promo's back-order. Blocks with the cross-basket
    // modal when an instore basket is active, or the cross-promo modal when a
    // *different* promo's basket is in use. Same-promo actions pass through.
    guardPromoAction: <Args extends unknown[]>(
      targetPromoId: number,
      action: (...args: Args) => void
    ) =>
      (...args: Args) => {
        if (instoreActive) {
          blockBasket();
          return;
        }
        if (basket && basket.promo_id !== targetPromoId) {
          blockPromo();
          return;
        }
        action(...args);
      },
    // Run `action` unless the promo basket is in use.
    guardInstoreAction: <Args extends unknown[]>(
      action: (...args: Args) => void
    ) =>
      (...args: Args) => {
        if (promoActive) {
          blockBasket();
          return;
        }
        action(...args);
      },
  };
}
